export const trimValues = (obj: any) => {
  const trimmedObj: any = {};
  for (const key in obj) {
    if (typeof obj[key] === "string") {
      trimmedObj[key] = obj[key].trim();
    } else if (
      typeof obj[key] === "object" &&
      obj[key] !== null &&
      !Array.isArray(obj[key])
    ) {
      trimmedObj[key] = trimValues(obj[key]); // Recursively trim nested objects
    } else {
      trimmedObj[key] = obj[key];
    }
  }
  return trimmedObj;
};